import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { fetchTranslations } from "shared/utils/contentful";

const getQueryParam = (param: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

const getLastPathSegment = () => {
  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  return pathSegments[pathSegments.length - 1] || "defaultResourceSet";
};

const queryLang = getQueryParam("lang") || "en";
const resourceSetName = getLastPathSegment();

export async function initI18n() {
  await i18n.use(initReactI18next).init({
    lng: queryLang,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    resources: {},
    react: { useSuspense: false },
    defaultNS: "translation",
  });

  try {
    const translations = await fetchTranslations(queryLang, resourceSetName);

    if (Object.keys(translations).length > 0) {
      i18n.addResourceBundle(
        queryLang,
        "translation",
        translations,
        true,
        true
      );
    }
  } catch (error) {
    console.error("Error fetching translations:", error);
  }

  return i18n;
}
